import script from "./SkillLanguageConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillLanguageConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillLanguageConfirmView.vue?vue&type=style&index=0&id=6f4340aa&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f4340aa"]])

export default __exports__